import { stringify } from 'qs';

import { FormReviewFlatModeParams } from './types';

export const routes = {
  root: '/',
  forgotPassword: {
    createPath: () => '/forgot-password/',
    mask: '/forgot-password/',
  },
  error: {
    createPath: () => '/error/',
    mask: 'error',
    forbidden: {
      createPath: () => '/error/forbidden/',
      mask: 'forbidden',
    },
  },
  register: {
    createPath: () => '/register/',
    mask: '/register/',
  },
  form: {
    createPath: () => '/forms/',
    mask: '/forms/*',
    initForm: {
      createPath: () => '/forms/init/',
      mask: '/init/',
    },
    formSteps: {
      mask: ':id/',
      createPath: (id: number) => `/forms/${id}`,
    },
    formReview: {
      mask: 'review/:id',
      createPath: (id: number) => `/forms/review/${id}`,
      flat: {
        mask: 'flat/',
        createPath: ({ rootId, id }: FormReviewFlatModeParams) =>
          `/forms/review/${id}/flat?${stringify({
            rootId,
          })}`,
      },
    },
  },
};
